export const ItemTypes = {
  PARAMETER: "parameter",
  CHOICE: "choice",
  FUNCTION: "function",
  EXPRESSION: "expression",
  CONDITION: "condition",
};
